/// <reference types="./tab_bar.d.mts" />
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $tab_bar from "../../../../ds/ds/components/tab_bar.mjs";
import * as $cypress from "../../../../ds/ds/cypress.mjs";
import * as $window from "../../../../ds/web/browser/window.mjs";
import * as $bool from "../../../../gleam_stdlib/gleam/bool.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $result from "../../../../gleam_stdlib/gleam/result.mjs";
import * as $uri from "../../../../gleam_stdlib/gleam/uri.mjs";
import * as $attribute from "../../../../lustre/lustre/attribute.mjs";
import * as $el from "../../../../lustre/lustre/element.mjs";
import * as $msg from "../../../data/msg.mjs";
import * as $route from "../../../data/route.mjs";
import {
  Ok,
  toList,
  prepend as listPrepend,
  CustomType as $CustomType,
  makeError,
  isEqual,
} from "../../../gleam.mjs";

const FILEPATH = "src/frontend/view/components/tab_bar.gleam";

class None extends $CustomType {}

class Action extends $CustomType {
  constructor(child) {
    super();
    this.child = child;
  }
}

class Tab extends $CustomType {
  constructor(active, href, disabled, children) {
    super();
    this.active = active;
    this.href = href;
    this.disabled = disabled;
    this.children = children;
  }
}

export function tab(to, children) {
  let _block;
  let _pipe = $window.location();
  let _pipe$1 = $uri.parse(_pipe);
  _block = $result.map(_pipe$1, $route.from_uri);
  let $ = _block;
  if (!($ instanceof Ok)) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "frontend/view/components/tab_bar",
      26,
      "tab",
      "Pattern match failed, no pattern matched the value.",
      { value: $, start: 494, end: 589, pattern_start: 505, pattern_end: 514 }
    )
  }
  let route = $[0];
  let active = isEqual(route, to);
  let _block$1;
  let _pipe$2 = $route.to_uri(to);
  _block$1 = $uri.to_string(_pipe$2);
  let href = _block$1;
  return new Tab(active, href, false, children);
}

export function disabled(tab, disabled) {
  if (tab instanceof None) {
    return new None();
  } else if (tab instanceof Action) {
    return tab;
  } else {
    let _record = tab;
    return new Tab(_record.active, _record.href, disabled, _record.children);
  }
}

export function action(element) {
  return new Action(element);
}

export function none() {
  return new None();
}

function actions(tabs) {
  return $list.map(
    tabs,
    (tab) => {
      if (tab instanceof None) {
        return $el.none();
      } else if (tab instanceof Action) {
        let child = tab.child;
        return child;
      } else {
        return $el.none();
      }
    },
  );
}

export function tab_bar(tabs) {
  return $l.row(
    toList([$l.align("center"), $l.shrink(0.0)]),
    toList([]),
    listPrepend(
      $tab_bar.tab_bar(
        toList([$cypress.data("tabs-navbar")]),
        $list.map(
          tabs,
          (tab) => {
            if (tab instanceof None) {
              return $el.none();
            } else if (tab instanceof Action) {
              return $el.none();
            } else {
              let active = tab.active;
              let href = tab.href;
              let disabled$1 = tab.disabled;
              let children = tab.children;
              let href$1 = $attribute.href(href);
              let disabled$2 = $attribute.attribute(
                "disabled",
                $bool.to_string(disabled$1),
              );
              return $tab_bar.tab(
                active,
                toList([href$1, disabled$2]),
                children,
              );
            }
          },
        ),
      ),
      actions(tabs),
    ),
  );
}
